import {
    Box,
    Typography,
    IconButton,
    Checkbox,
    TableRow,
    TableCell,
    TableBody,
} from '@mui/material';

// import CheckCircleOutlineRounded from '@mui/icons-material/CheckCircleOutlineRounded';
// import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

// import Timeline from '@mui/lab/Timeline';
// import TimelineItem from '@mui/lab/TimelineItem';
// import TimelineSeparator from '@mui/lab/TimelineSeparator';
// import TimelineConnector from '@mui/lab/TimelineConnector';
// import TimelineContent from '@mui/lab/TimelineContent';
// import TimelineDot from '@mui/lab/TimelineDot';
// import TimelineOppositeContent, {
//     timelineOppositeContentClasses,
// } from '@mui/lab/TimelineOppositeContent';

// import format from 'date-fns/format';

// import { useEffect, useState } from 'react';
// import { useSelector } from 'react-redux';


const ActionItemTableBody = ({ actionItemsFromId, fromId, date, checkedItems, setCheckedItems }) => {
    const handleCheckActionItem = (item, fromId, date) => {
        let checked = { ...checkedItems };
        const arr = checked[`${fromId}: ${date}`] || [];

        if (!arr.includes(item)) arr.push(item);
        else {
            const idx = arr.indexOf(item);
            arr.splice(idx, idx+1);
        }

        checked[`${fromId}: ${date}`] = arr;
        setCheckedItems(checked);
    };

    return (
        <TableBody>
            {Array.from(actionItemsFromId)?.map((actionItem) => {
                return(
                    <TableRow>
                        <TableCell>
                            <Checkbox
                                color="primary"
                                sx={{ '& .MuiSvgIcon-root': { fontSize: 15, margin: 0.01 } }}
                                checked={checkedItems[`${fromId}: ${date}`].includes(actionItem.item)}
                                onClick={() => handleCheckActionItem(actionItem.item, fromId, date)}
                            />
                        </TableCell>
                        <TableCell sx={{ maxWidth: '200px', overflowX: 'hidden', textOverflow: 'ellipsis'}} spacing={2}>
                            <Box>
                                {!checkedItems[`${fromId}: ${date}`].includes(actionItem.item) ?
                                    (
                                        <Typography 
                                            variant="tableBody"
                                        >
                                            {actionItem.item}
                                        </Typography>
                                    ) :
                                    (
                                        <Typography 
                                            variant="tableBody" 
                                            sx={{ 							
                                                textDecoration: "line-through",
                                            }}
                                        >
                                            {actionItem.item}
                                        </Typography>                                   
                                    )
                                }
                            </Box>
                        </TableCell>

                        {/* Extra table cell for formatting */}
                        <TableCell></TableCell>
                    </TableRow>
                );
            })}
        </TableBody>
    );
};

export default ActionItemTableBody;